import './blogCtrl';
import './articleCtrl';


// WEBPACK FOOTER //
// src/js/controllers/blog/index.js